import { createAction } from '@reduxjs/toolkit';

import { getFailurePayload, getRequestPayload, getSuccessPayload } from 'modules/utils';

import * as actionTypes from './actionTypes';

export const acceptRentalDocuments = createAction(
  actionTypes.ACCEPT_RENTAL_DOCUMENTS,
  getRequestPayload({ method: 'POST' })
);
export const acceptRentalDocumentsSuccess = createAction(actionTypes.ACCEPT_RENTAL_DOCUMENTS_SUCCESS);
export const acceptRentalDocumentsFailure = createAction(
  actionTypes.ACCEPT_RENTAL_DOCUMENTS_FAILURE,
  getFailurePayload
);

export const acceptRepairOrder = createAction(actionTypes.ACCEPT_REPAIR_ORDER, (url, advices) => ({
  payload: {
    request: {
      method: 'POST',
      url,
      data: { advices },
    },
  },
}));
export const acceptRepairOrderSuccess = createAction(actionTypes.ACCEPT_REPAIR_ORDER_SUCCESS, appointment => ({
  payload: appointment,
}));
export const acceptRepairOrderFailure = createAction(actionTypes.ACCEPT_REPAIR_ORDER_FAILURE, getFailurePayload);

export const confirmClientDocuments = createAction(actionTypes.CONFIRM_CLIENT_DOCUMENTS, (url, documents) => ({
  payload: { request: { method: 'POST', url, data: { documents } } },
}));
export const confirmClientDocumentsSuccess = createAction(
  actionTypes.CONFIRM_CLIENT_DOCUMENTS_SUCCESS,
  getSuccessPayload
);
export const confirmClientDocumentsFailure = createAction(
  actionTypes.CONFIRM_CLIENT_DOCUMENTS_FAILURE,
  getFailurePayload
);

export const payBilling = createAction(actionTypes.PAY_ONLINE_BILLING, getRequestPayload());
export const payBillingSuccess = createAction(actionTypes.PAY_ONLINE_BILLING_SUCCESS);
export const payBillingFailure = createAction(actionTypes.PAY_ONLINE_BILLING_FAILURE, getFailurePayload);

export const reportIssues = createAction(actionTypes.REPORT_ISSUES, (url, issues) => ({
  payload: {
    request: {
      method: 'POST',
      url,
      data: {
        issues: issues?.map(issue => ({
          ...issue,
          medias: issue.medias?.map(
            ({ id, contentType, uploadId, name: filename }) => ({ id, contentType, uploadId, filename })
          ),
        })),
      },
    },
  },
}));
export const reportIssuesSuccess = createAction(actionTypes.REPORT_ISSUES_SUCCESS, getSuccessPayload);
export const reportIssuesFailure = createAction(actionTypes.REPORT_ISSUES_FAILURE, getFailurePayload);

export const confirmDropOff = createAction(actionTypes.CONFIRM_DROPOFF, getRequestPayload({ method: 'POST' }));
export const confirmDropOffSuccess = createAction(actionTypes.CONFIRM_DROPOFF_SUCCESS);
export const confirmDropOffFailure = createAction(actionTypes.CONFIRM_DROPOFF_FAILURE, getFailurePayload);

export const openDropOffLocker = createAction(actionTypes.OPEN_DROPOFF_LOCKER, (url, locationId) => ({
  payload: { request: { method: 'POST', url, data: { locationId } } },
}));
export const openDropOffLockerSuccess = createAction(actionTypes.OPEN_DROPOFF_LOCKER_SUCCESS);
export const openDropOffLockerFailure = createAction(actionTypes.OPEN_DROPOFF_LOCKER_FAILURE, getFailurePayload);

export const confirmPickUp = createAction(actionTypes.CONFIRM_PICK_UP, getRequestPayload({ method: 'POST' }));
export const confirmPickUpSuccess = createAction(actionTypes.CONFIRM_PICK_UP_SUCCESS);
export const confirmPickUpFailure = createAction(actionTypes.CONFIRM_PICK_UP_FAILURE, getFailurePayload);

export const openPickUpLocker = createAction(actionTypes.OPEN_PICK_UP_LOCKER, (url, locationId) => ({
  payload: { request: { method: 'POST', url, data: { locationId } } },
}));
export const openPickUpLockerSuccess = createAction(actionTypes.OPEN_PICK_UP_LOCKER_SUCCESS);
export const openPickUpLockerFailure = createAction(actionTypes.OPEN_PICK_UP_LOCKER_FAILURE, getFailurePayload);
